import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { businessActions } from '../../business';
import { apiActionResult, apiActions as commonApiActions, convertApiAction } from "../../common";
import { INVITATION_SIGN_UP_ENDPOINT } from './endpoints';
import { getCurrentUser } from './getCurrent';
import { getIndustryRoles } from './getIndustryRoles';
import { auth0SignUpAndLogin } from './signup';
import { userActionTypes } from './util';

const actions = createActions({
  USER: {
    INVITATION_SIGN_UP: (invitationSignUpPayload) => ({ invitationSignUpPayload }),
    API: {
      INVITATION_SIGN_UP: userActionTypes()
    }
  }
})

export const apiAction = (authToken, invitationSignUpPayload) => commonApiActions.authenticated.post(INVITATION_SIGN_UP_ENDPOINT, authToken, invitationSignUpPayload, actions.user.api.invitationSignUp)

export function* invitationSignUp({
  payload: {
    invitationSignUpPayload
  }
}) {
  yield put(businessActions.business.verifyInvitation(invitationSignUpPayload.invitationToken, invitationSignUpPayload.businessId));

  const tokenVerificationResult = yield apiActionResult(businessActions.business.api.verifyInvitation);

  if (tokenVerificationResult.success) {
    // Before this, check the invitation status.S
    const signUpResult = yield* auth0SignUpAndLogin(invitationSignUpPayload, actions.user.api.invitationSignUp, apiAction, true);

    if (signUpResult && signUpResult.success) {
      const reFetchIndustry = yield* getIndustryRoles();
      yield* getCurrentUser();

      if (reFetchIndustry) {
        yield put(push({ pathname: routes.app.dashboard }));
      }
    }
  }
  else {
    yield put(convertApiAction(actions.user.api.invitationSignUp.failed(), {
      description: tokenVerificationResult.failed && tokenVerificationResult.failed.payload ?
        tokenVerificationResult.failed.payload.error :
        'Something is wrong when accepting the invitation, please contact Caddie support.'
    }));
  }
}

const configuration = {
  name: 'invitationSignUp',
  action: actions,
  sagas: invitationSignUp,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        roleAssignments: state.currentUser.roleAssignments,
        teamMemberRoles: state.currentUser.teamMemberRoles,
        ...action.payload.user
      },
      isFetching: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/invitationSignUp.js